module.exports = __webpack_public_path__ + "assets/img/calendar.b4dc6e30.svg";